import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { laaSFormatString } from 'src/app/core/utils/common-functions';

/**
 * 相同地址DO勾選面板：純選擇用途，不呼叫任何API。
 * 使用者按「確定」關閉面板時，把目前勾選的doNo清單emit給父元件(address-management)，
 * 由父元件在使用者按下主流程的「確認」按鈕時，跟這筆DO自己的地址confirm合併成同一個動作一起送出。
 */
@Component({
  selector: 'laas-same-address-apply',
  templateUrl: './same-address-apply.component.html',
  styleUrls: ['./same-address-apply.component.scss']
})
export class SameAddressApplyComponent extends BaseComponent implements OnChanges {

  @Input() display = false;
  @Input() candidates: any[] = [];
  @Input() lookbackDays = 0;
  @Output() selectionChanged = new EventEmitter<string[]>();

  selected: { [doNo: string]: boolean } = {};

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // 每次換一批新的候選清單(切換到新的DO)，重設勾選狀態，預設全部不勾選
    if (changes.candidates) {
      this.selected = {};
    }
  }

  isAllSelected(): boolean {
    return this.candidates.length > 0 && this.candidates.every(row => this.selected[row.doNo]);
  }

  toggleSelectAll(checked: boolean): void {
    this.candidates.forEach(row => {
      this.selected[row.doNo] = checked;
    });
  }

  toggleRow(doNo: string): void {
    this.selected[doNo] = !this.selected[doNo];
  }

  // Message文字裡的「近N天內」要跟後端AppCsmSetting實際設定的回看天數一致，不能寫死
  getMessageText(): string {
    return laaSFormatString(
      this.translateService.instant('Address.SameAddress.Message'),
      [String(this.lookbackDays)]
    );
  }

  close(): void {
    // display二值繫結+(onHide)可能都會觸發這裡(不管使用者是點確定、點空白處還是按ESC關閉)，
    // 故意不加「已經是false就return」的guard——那樣反而會在PrimeNG自己先同步display=false的
    // 關閉路徑下，讓這裡整段被跳過、沒emit出去，導致父層的showSameAddressDialog沒被重設，
    // 下次再打開就沒反應。重複呼叫本身無害，頂多重複設同一個值。
    this.display = false;
    const doNos = Object.keys(this.selected).filter(doNo => this.selected[doNo]);
    this.selectionChanged.emit(doNos);
  }
}
